/*eslint-disable*/
import { useState, useEffect, useRef, createRef } from "react";
import {
    Row,
    Col,
    ListGroupItem,
    ListGroup,
    ListGroupItemHeading,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from "reactstrap";
import client from "../../common/api";
import { ADD_EDIT_ROLES } from "../../common/Utils";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faCircleCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useTranslation } from "react-i18next";
import './roadmap.public.scss';
import SingleRoadmapItem from "../../common/roadmap/SingleItem/SingleRoadmapItem";
import PlannedIcon from '../../../assets/images/public/p-planned-icon.svg';
import ProgressIcon from '../../../assets/images/public/p-progress-icon.svg';
import CompleteIcon from '../../../assets/images/public/p-complete-icon.svg';

const roadmapColumns = [
    { id: 'planned', label: 'Planned', group: 'plannedRoadmaps' },
    { id: 'progress', label: 'In Progress', group: 'progressRoadmaps' },
    { id: 'complete', label: 'Complete', group: 'completeRoadmaps' },
];

const publicHeading = 'Product Roadmap';
const publicSubHeading = 'Discover our future plans and upcoming features as we continue to innovate.';

const RoadmapFeature = ({
    allRoadmaps,
    poweredBy,
    openRoadmapDetails,
    createUpvotes,
    location,
    handleOnDragEnd,
    getAllRoadmaps,
    companyInfo,
    userInfo
}) => {
    const [plannedRoadmaps, setPlannedRoadmaps] = useState([]);
    const [progressRoadmaps, setProgressRoadmaps] = useState([]);
    const [completeRoadmaps, setCompleteRoadmaps] = useState([]);
    const [allCategories, setAllCategories] = useState([]);
    const [createRoadmapAlert, setCreateRoadmapAlert] = useState({
        show: false,
        text: '',
        type: '',
    });
    const [createRoadmapTextarea, setCreateRoadmapTextarea] = useState({
        show: false,
        value: '',
        group: '',
        category: '',
    });
    const {
        roadmap_title,
        roadmap_description,
    } = companyInfo || {};
    const colRefs = useRef([createRef(), createRef(), createRef()]);
    const { t, i18n } = useTranslation();
    const activeSpace = window.location.host.split('.')[0];
    const inlineBtnDisableCondition = !createRoadmapTextarea.value;
    const canCreateRoadmap = userInfo?.roles?.some(role => role.workspace === activeSpace && ADD_EDIT_ROLES.includes(role.name));

    const filterAllRoadmaps = () => {
        // write code to filter allRoadmaps according to status open, planned, progress, complete
        const plannedRoadmaps = allRoadmaps.filter(roadmap => roadmap.status === 'planned');
        const progressRoadmaps = allRoadmaps.filter(roadmap => roadmap.status === 'progress');
        const completeRoadmaps = allRoadmaps.filter(roadmap => roadmap.status === 'complete');

        setPlannedRoadmaps(plannedRoadmaps);
        setProgressRoadmaps(progressRoadmaps);
        setCompleteRoadmaps(completeRoadmaps);
    };

    const onRoadmapClick = (roadmap) => {
        openRoadmapDetails(roadmap);
    };

    const getIcon = (status) => {
        if (status === 'planned') {
            return <img src={PlannedIcon} className="status-icon" />;
        } else if (status === 'progress') {
            return <img src={ProgressIcon} className="status-icon" />;
        } else if (status === 'complete') {
            return <img src={CompleteIcon} className="status-icon" />;
        }
    };

    const openCreateRoadmap = (item, itemIndex) => {
        //const colRef = colRefs.current[itemIndex].current;
        const colRef = document.getElementById(`col-${itemIndex}-${item.id}`);
        setTimeout(function () {
            colRef.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }, 100);
        //colRef.scrollIntoView({ behavior: 'smooth', block: "start" });
        setCreateRoadmapTextarea({
            show: true,
            value: '',
            group: item.id,
        });
    };

    const fetchCategories = () => {
        client.get('/feedback/get/categories', { params: { activeSpaceName: activeSpace } }).then(response => {
            const codeResp = response.data;
            if (codeResp.success) {
                setAllCategories(codeResp.data);
            }
        })
    };

    const categoryHandler = (category) => {
        setCreateRoadmapTextarea({ ...createRoadmapTextarea, category: category });
    };

    const saveRoadmap = () => {
        const payload = {
            title: createRoadmapTextarea.value,
            category: createRoadmapTextarea.category,
            status: createRoadmapTextarea.group,
            activeSpace: activeSpace,
            description: '',
            htmlDescription: '',
            emoji: '',
        };
        client.post('/feedback/create', payload).then(response => {
            const codeResp = response.data;
            if (codeResp.success) {
                setCreateRoadmapAlert({
                    show: true,
                    text: 'Roadmap created successfully',
                    type: 'success',
                });

                setTimeout(() => {
                    getAllRoadmaps();
                    setCreateRoadmapAlert({
                        show: false,
                        text: '',
                        type: '',
                    });
                    setCreateRoadmapTextarea({
                        show: false,
                        value: '',
                        category: '',
                    });
                }, 2000);
            } else {
                setCreateRoadmapAlert({
                    show: true,
                    text: 'Roadmap creation failed',
                    type: 'error',
                });
            }
        })
    };

    // function to hide the inline feedback form when clicked outside
    const useOutsideAlerter = (ref) => {
        useEffect(() => {
            /**
             * Alert if clicked on outside of element
             */
            const handleClickOutside = (event) => {
                if (ref.current && !ref.current.contains(event.target)) {
                    setCreateRoadmapTextarea({
                        show: false,
                        value: '',
                        category: '',
                    });
                }
            }
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    };

    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef);

    useEffect(() => {
        filterAllRoadmaps();
    }, [allRoadmaps]);

    useEffect(() => {
        fetchCategories();
    }, []);

    return (
        <div className="roadmap-feature">
            {
                location !== 'dashboard' && (
                    <div className="public-content-header">
                        <h4 className="public-content-title">{roadmap_title}</h4>
                        <p className="public-content-subtitle">{roadmap_description}</p>
                    </div>
                )
            }
            <DragDropContext onDragEnd={handleOnDragEnd}>
                <Row>
                    {
                        roadmapColumns.map((item, itemIndex) => {
                            let _group = [];
                            if (item.group === 'plannedRoadmaps') {
                                _group = plannedRoadmaps;
                            } else if (item.group === 'progressRoadmaps') {
                                _group = progressRoadmaps;
                            } else if (item.group === 'completeRoadmaps') {
                                _group = completeRoadmaps;
                            }
                            return (
                                <Col key={item.id} id={itemIndex} className="roadmap-col" >
                                    <ListGroup className={`roadmap-group ${location === 'dashboard' && 'admin-view'} ${_group.length === 0 && 'empty-col'}`}>
                                        <ListGroupItem className={`list-roadmap-heading pl-${item.id}`}>
                                            <ListGroupItemHeading>
                                                {getIcon(item.id)}
                                                {/* for dashboard, then show the label, else show the translated label */}
                                                {
                                                    location !== 'dashboard' ? t(item.id) : item.label
                                                }
                                                <span className="roadmap-count">
                                                    {_group.length}
                                                </span>
                                            </ListGroupItemHeading>
                                        </ListGroupItem>

                                        <Droppable droppableId={item.id} key={item.id} index={itemIndex}>
                                            {(provided, snapshot) => (
                                                <div className="roadmap-items" {...provided.droppableProps} ref={provided.innerRef}>
                                                    {
                                                        _group.map((roadmap, index) => (
                                                            <Draggable key={roadmap._id['$oid']} draggableId={roadmap._id['$oid']} isDragDisabled={location !== 'dashboard'} index={index}>
                                                                {(provided, snapshot) => (
                                                                    <div ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                        style={{
                                                                            ...provided.draggableProps.style,
                                                                            backgroundColor: snapshot.isDragging ? '#f0f0f0' : 'white',
                                                                        }}>
                                                                        <SingleRoadmapItem
                                                                            onRoadmapClick={onRoadmapClick}
                                                                            roadmap={roadmap}
                                                                            index={index}
                                                                            upvoteHandler={createUpvotes}
                                                                            pageType={'public-roadmap'}
                                                                            key={index}
                                                                            location={location}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </Draggable>
                                                        ))
                                                    }
                                                    {
                                                        _group.length === 0 && (
                                                            <ListGroupItem className="list-roadmap-empty">
                                                                <div className="empty-title">{t("no_posts")}</div>
                                                            </ListGroupItem>
                                                        )
                                                    }
                                                    {
                                                        (location === 'dashboard' && createRoadmapTextarea.show && createRoadmapTextarea.group === item.id) && (
                                                            <div ref={wrapperRef} className="roadmap-create-textarea-wrapper">
                                                                <textarea
                                                                    className="roadmap-create-textarea"
                                                                    placeholder="What are the next action items?"
                                                                    value={createRoadmapTextarea.value}
                                                                    ref={wrapperRef}
                                                                    onChange={(e) => setCreateRoadmapTextarea({ ...createRoadmapTextarea, value: e.target.value })}
                                                                />
                                                                <div className="roadmap-create-textarea-footer">
                                                                    <UncontrolledDropdown className="roadmap-create-textarea-footer-dropdown">
                                                                        <DropdownToggle
                                                                            caret
                                                                            className="nav-link"
                                                                            tag="a"
                                                                        >
                                                                            {createRoadmapTextarea.category || 'Select Category'}
                                                                        </DropdownToggle>
                                                                        <DropdownMenu>
                                                                            {
                                                                                allCategories?.map((category) => (
                                                                                    <DropdownItem
                                                                                        dropDownValue={category.name}
                                                                                        onClick={(ev) => { categoryHandler(category.name); ev.preventDefault() }}
                                                                                    >
                                                                                        {category.name}
                                                                                    </DropdownItem>
                                                                                ))
                                                                            }
                                                                        </DropdownMenu>
                                                                    </UncontrolledDropdown>
                                                                    <button
                                                                        disabled={inlineBtnDisableCondition}
                                                                        className="btn roadmap-create-inline-btn"
                                                                        onClick={() => saveRoadmap()}
                                                                    >Save
                                                                        {
                                                                            createRoadmapAlert.show && (
                                                                                <>
                                                                                    {
                                                                                        createRoadmapAlert.type === 'success' && (
                                                                                            <FontAwesomeIcon icon={faCircleCheck} className="ml-2" />
                                                                                        )
                                                                                    }
                                                                                    {
                                                                                        createRoadmapAlert.type === 'error' && (
                                                                                            <FontAwesomeIcon icon={faCircleXmark} className="ml-2" />
                                                                                        )
                                                                                    }
                                                                                </>
                                                                            )
                                                                        }
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                    <div ref={colRefs.current[itemIndex]} id={`col-${itemIndex}-${item.id}`}>&nbsp;</div>
                                                </div>
                                            )}
                                        </Droppable>
                                    </ListGroup>

                                    {
                                        location === 'dashboard' && (
                                            <div className="roadmap-col-footer">
                                                <button className={`btn roadmap-create-btn ${!canCreateRoadmap ? 'disabled' : ''}`} onClick={() => openCreateRoadmap(item, itemIndex)}>
                                                    <FontAwesomeIcon icon={faPlus} className="mr-2" />Add New
                                                </button>
                                            </div>
                                        )
                                    }
                                </Col>
                            )
                        })
                    }
                </Row>
            </DragDropContext>
            {
                poweredBy && (
                    <p className="poweredby-link">
                        <a href={poweredBy} target="_blank">
                            <svg width="8" height="15" stroke="#000000a2"
                                stroke-width="2" style={{ marginRight: '4px' }}>
                                <path fill="#F9C933" fill-rule="evenodd" stroke="#EE8B00" stroke-width=".8" d="M4.256 5.777h3.65L.716 15.935l2.721-7.927H.14l6.503-10.08-2.387 7.849z"></path>
                            </svg> by ProductLogz
                        </a>
                    </p>
                )
            }

        </div >
    );
};

export default RoadmapFeature;
